export default function VPNService() {
  const services = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Encryption',
      description: 'Your data is protected with AES-256 encryption, the same standard used by governments and security experts worldwide.',
      gradient: 'from-blue-500 to-cyan-500'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Connect to high-speed servers across multiple countries and enjoy unrestricted access to content from anywhere.',
      gradient: 'from-purple-500 to-pink-500'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Lightning Fast Speed',
      description: 'Experience blazing-fast connection speeds with our optimized servers. Stream, browse, and download without limits.',
      gradient: 'from-orange-500 to-red-500'
    }
  ];

  return (
    <section id="vpn-service" className="py-24 bg-gradient-to-b from-purple-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-purple-600 font-semibold text-sm uppercase tracking-wider">
            OUR SERVICE
          </span>
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mt-4 mb-6">
            Premium VPN Service
            <br />
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              Built for Your Security
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer group"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${service.gradient} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
